import { Image } from 'react-bootstrap';
import Community from '../../assets/images/community.png';
import Impact from '../../assets/images/impact.png';
import Innovation from '../../assets/images/innovation.png';
import Inspiration from '../../assets/images/inspiration.png';
import Trust from '../../assets/images/trust.png';
import './CoreValuesGrid.css';

interface CoreValueItem {
  label: string;
  image: string;
  inspiration?: boolean;
}

const CORE_VALUES: CoreValueItem[] = [
  { label: 'Trust', image: Trust },
  { label: 'Impact', image: Impact },
  { label: 'Innovation', image: Innovation },
  { label: 'Community', image: Community },
  { label: 'Inspiration', image: Inspiration, inspiration: true },
];

export const CoreValuesGrid = () => (
  <div className="w-100 core-values">
    {CORE_VALUES.map(({ label, image, inspiration }) => (
      <div
        key={label}
        className="box-values text-uppercase"
      >
        <div className={`box-image-container${inspiration ? ' inspiration-img' : ''}`}>
          <Image src={image} className="box-values-image" alt={label} />
        </div>
        <span className="box-values-label">{label}</span>
      </div>
    ))}
  </div>
);
